import { Icon } from "design-react-kit";
import React from "react";

const TableSearch = ({
  setResults,
  items,
  filterHandler,
  text,
  column,
  value,
}) => {
  const changeHandler = (e) => {
    if (column !== undefined && items !== undefined) {
      return setResults(filterHandler(e, items, column));
    } else if (column === undefined && items === undefined) {
      return filterHandler(e);
    } else {
      return setResults(filterHandler(e, items));
    }
  };

  return (
    <div className="col col-8 col-sm-6 col-lg-3 border border-secondary mb-4 search p-1">
      <div className="d-flex justify-content-end">
        <div className="input-group-prepend">
          <div className="input-group-text  border-0 py-0">
            <Icon icon="it-search" aria-hidden size="xs" />
          </div>
        </div>
        <input
          type="text"
          placeholder={text}
          defaultValue={value}
          className="form-control border-0 py-0 mt-0"
          id="table-search"
          name="table-search"
          onChange={(e) => changeHandler(e)}
        />
      </div>
    </div>
  );
};

export default TableSearch;
